import { inject } from '../utils';
import { refreshOAuthToken, logout } from '../utils/api';

class ReduxAuthService {
  constructor(store, session) {
    this.store = store;
    this.session = session;
    this.refreshOAuthToken = refreshOAuthToken;
    this.logout = logout;
  }

  getAuthHeader() {
    return `Bearer ${this.session.getAccessToken()}`;
  }

  load() {
    // noop, currenly auth loading steps injected in App component
    return Promise.resolve(this);
  }

  login() {
    this.refreshOAuthToken();
  }

  logout() {
    this.logout();
  }
}

inject(ReduxAuthService, ['Store', 'SessionService']);
export default ReduxAuthService;



// WEBPACK FOOTER //
// ./src/services/ReduxAuthService.js